// constants
const { LOCAL_ENVIRONMENT, DEV_ENVIRONMENT, QA_ENVIRONMENT, STAGING_ENVIRONMENT, OCULTO_ENVIRONMENT, PRODUCTION_ENVIRONMENT } = require('constants/index');

const getCallbackUrl = (environment, url) => {
    switch (environment) {
        case LOCAL_ENVIRONMENT:
            return `http://localhost:9000/${url}`;
        case DEV_ENVIRONMENT:
            return `http://clientes.dev.openbank.es/${url}`;
        case QA_ENVIRONMENT:
            return `http://clientes.qa.openbank.es/${url}`;
        case STAGING_ENVIRONMENT:
            return `http://clientes.stg.openbank.es/${url}`;
        case OCULTO_ENVIRONMENT:
            return `http://clientes.ocu.openbank.es/${url}`;
        case PRODUCTION_ENVIRONMENT:
            return `http://clientes.openbank.es/${url}`;
        default:
            throw new Error(`Unknown environment '${environment}'.`)
    }
};

export default getCallbackUrl;